<template>
  <div class="page home">

    <div id="start" class="section">
      <div class="schabbellLogo">Schabbell – Museum Leben Welterbe</div>
      <!-- <img src="../assets/schabbell_aussen.jpg" alt="Das Schabbell von außen"> -->
      <div class="schabbellHeroimg">
        <div class="innerContainer">
          <router-link to="/scene/Raum01" exact class="button big black tourstart">Jetzt 360°-Tour starten</router-link>
        </div>
      </div>
      <div class="cta_buttons">
        <a href="#info" title="zum Infotext" @click.prevent="" v-scroll-to="{ el: '#info', offset: 0 }" class="btnInfo">zum Infotext</a>
      </div>
    </div>

    <div id="info" class="section">
      <h1>Eine virtuelle Tour durch das Stadtgeschichtliche Museum der Hansestadt Wismar im Schabbell.</h1>
      <p>Tauchen Sie ein in unsere virtuelle Rundtour durch das Stadtgeschichtliche Museum der Hansestadt Wismar.</p>

      <hr class="dashed">

      <h2>Alle Informationen, alle Angebote:</h2>
      <p>
        <b>Web:</b> <a href="https://www.wismar.de/schabbell" target="_blank">www.wismar.de/schabbell</a><br>
        <b>Instagram:</b> <a href="https://www.instagram.com/schabbell.wismar/" target="_blank">@schabbell.wismar</a>
      </p>
      <h2>Öffnungszeiten:</h2>
      <p>
        <b>November - März:</b> Dienstag bis Sonntag 10:00 bis 16:00 Uhr<br>
        <b>April - Juni und Oktober:</b> Dienstag bis Sonntag 10:00 bis 18:00 Uhr<br>
        <b>Juli - September:</b> täglich 10:00 bis 18:00 Uhr<br>
      </p>
      <p>Das Schabbell ist weitgehend barrierefrei.</p>

      <hr class="dashed">

      <nav>
        <ul class="meta">
          <li><router-link to="/impressum" exact>Impressum</router-link></li>
          <li><router-link to="/datenschutz" exact>Datenschutzerklärung</router-link></li>
        </ul>
      </nav>

      <div class="cta_buttons">
        <a href="#" title="zurück zum Anfang" @click.prevent="" v-scroll-to="{ el: 'body' }" class="scrollUp">zurück zum Anfang</a>
      </div>


    </div>

    <!-- <nav class="col right">
      <img src="../assets/Schabbell-Logo.svg" alt="Schabbell Logo" class="logo">
      <ul>
        <li><router-link to="/" exact>Startseite</router-link></li>
        <li v-for="scene in scenes" :key="scene.sceneId"><router-link :to="'/scene/' + scene.sceneId" exact>{{(scene.title) ? scene.title : scene.sceneId}}</router-link></li>
      </ul>
      <ul class="meta">
        <li><router-link to="/impressum" exact>Impressum</router-link></li>
        <li><router-link to="/datenschutz" exact>Datenschutzerklärung</router-link></li>
      </ul>
    </nav> -->

  </div>
</template>

<script>

export default {
  name: 'Home',
  props: {
    scenes: {type: Object, default: () => {} },
  },
  data () {
    return {

    }
  },
  watch: {

  },
  mounted() {
    document.title = "Startseite | Schabbell 360";
  },
  created() {

  },
  beforeDestroy() {

  },
  computed: {

  },
  methods: {

  },
}
</script>
